var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.openMaterialSelectionDrawer();
      }
    }
  }, [_vm._v("管理材料")]), _c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('div', {
    staticClass: "handle-wrapper"
  }, [_c('h2', [_vm._v("产品")])]), _c('Table', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    attrs: {
      "loading": _vm.materialLoading,
      "columns": _vm.materialColumns,
      "data": _vm.filteredSacMaterialList('product')
    }
  })], 1), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('div', {
    staticClass: "handle-wrapper"
  }, [_c('h2', [_vm._v("母液")])]), _c('Table', {
    staticClass: "table",
    attrs: {
      "loading": _vm.materialLoading,
      "columns": _vm.materialColumns,
      "data": _vm.filteredSacMaterialList('semi')
    }
  })], 1), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('div', {
    staticClass: "handle-wrapper"
  }, [_c('h2', [_vm._v("复配小料")])]), _c('Table', {
    staticClass: "table",
    attrs: {
      "loading": _vm.materialLoading,
      "columns": _vm.materialColumns,
      "data": _vm.filteredSacMaterialList('raw')
    }
  })], 1)], 1), _c('Modal', {
    attrs: {
      "width": "600"
    },
    model: {
      value: _vm.materialSelectionModal,
      callback: function ($$v) {
        _vm.materialSelectionModal = $$v;
      },
      expression: "materialSelectionModal"
    }
  }, [_c('p', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-information-circle"
    }
  }), _c('span', [_vm._v("选择材料")])], 1), _c('div', [_c('CheckboxGroup', {
    model: {
      value: _vm.selectedMaterials,
      callback: function ($$v) {
        _vm.selectedMaterials = $$v;
      },
      expression: "selectedMaterials"
    }
  }, [_c('h3', [_vm._v("成品")]), _vm._l(_vm.filteredFullMaterialList('product'), function (e) {
    return _c('Checkbox', {
      key: e._id,
      attrs: {
        "label": e._id,
        "size": "large"
      }
    }, [_vm._v(_vm._s(e.name) + _vm._s(e.model))]);
  }), _c('h3', [_vm._v("母液")]), _vm._l(_vm.filteredFullMaterialList('semi'), function (e) {
    return _c('Checkbox', {
      key: e._id,
      attrs: {
        "label": e._id,
        "size": "large"
      }
    }, [_vm._v(_vm._s(e.name) + _vm._s(e.model))]);
  }), _c('h3', [_vm._v("复配小料")]), _vm._l(_vm.filteredFullMaterialList('raw'), function (e) {
    return _c('Checkbox', {
      key: e._id,
      attrs: {
        "label": e._id,
        "size": "large"
      }
    }, [_vm._v(_vm._s(e.name) + _vm._s(e.model))]);
  })], 2)], 1), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.saveMaterialLoading
    },
    on: {
      "click": _vm.saveMaterial
    }
  }, [_vm._v("保存")])], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }